import { DialogTrigger, DialogTriggerProps } from "react-aria-components";

export default function ModalLayoutTrigger(props: DialogTriggerProps) {
  return <DialogTrigger {...props} />;
}
